module.exports = __webpack_public_path__ + "img/Casting 4.1b19e3c5.jpg";